"use strict";

var _interopRequireDefault = require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
require("core-js/modules/es6.string.sub");
require("core-js/modules/es6.array.find-index");
var _regeneratorRuntime2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));
require("core-js/modules/es6.regexp.split");
var _createForOfIteratorHelper2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/createForOfIteratorHelper.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("D:/git\u4ED3\u5E93/xingxingzu/multi_merchant_web/supplier/node_modules/@babel/runtime/helpers/objectSpread2.js"));
var _cropUpload = _interopRequireDefault(require("@/components/cropUpload"));
var _wangEditor = _interopRequireDefault(require("@/components/wangEditor"));
var _index = require("@/api/index");
var _goods = require("@/api/goods");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  components: {
    cropUpload: _cropUpload.default,
    textEditor: _wangEditor.default
  },
  props: ['editId', 'activeTab', 'draftId'],
  data: function data() {
    return {
      submitForm: {
        category_id: null,
        goods_name: "",
        spread_title: "",
        new_grade: '100',
        rent_label: [],
        imgurl: "",
        carousel_img: [],
        goods_sort: 0,
        goods_content: "",
        rent_content: "",
        supervise_content: "",
        content_type: 0,
        is_relet: 0,
        pact_type: '3',
        province: [],
        service_address: "",
        send_out: '1',
        return: '1',
        transfer_cost: ""
      },
      contentTypeList: ['默认', '租赁说明', '监管说明'],
      rules: {
        carousel_img: [{
          required: true,
          message: '请上传商品图片',
          trigger: 'blur'
        }],
        province: [{
          required: true,
          message: '请选择服务城市',
          trigger: 'change'
        }],
        category_id: [{
          required: true,
          message: '请选择商品品类',
          trigger: 'change'
        }],
        goods_name: [{
          required: true,
          message: '请输入商品名称',
          trigger: 'blur'
        }],
        imgurl: [{
          required: true,
          message: '请上传商品封面',
          trigger: 'change'
        }],
        new_grade: [{
          required: true,
          message: '请选择新旧程度',
          trigger: 'change'
        }]
      },
      areaList: [],
      // 服务城市
      adsList: [],
      // 租赁地址
      categoryList: [],
      //品类列表
      optionProps: {
        value: 'id',
        label: 'name',
        expandTrigger: 'hover',
        children: 'sub'
      },
      initData: {
        new_grade: {},
        // 新旧程度
        rent_label: [],
        // 标签
        pact_type: [],
        // 租赁方式
        send_out: {},
        // 寄出
        return: {},
        // 归还
        shop_address: [] // 租赁地址
      },

      goodsParams: [],
      // 商品参数
      status: 2,
      // 商品审核后上架/下架
      hideAuditBtn: false
    };
  },
  methods: {
    goToRentAd: function goToRentAd() {
      var _this = this;
      this.$confirm('跳转前请先保存草稿，确认继续跳转吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(function () {
        _this.$router.push({
          name: 'shopRentAd'
        });
      }).catch(function () {});
    },
    // 提交审核
    submitAudit: function submitAudit() {
      var _this2 = this;
      (0, _goods.goodsSubmitReview)(this.editId).then(function (res) {
        _this2.$router.push({
          name: 'goodsSuccess',
          params: {
            goodsId: _this2.editId,
            isEdit: true
          }
        });
      });
    },
    // 保存草稿
    saveToDraft: function saveToDraft() {
      var _this3 = this;
      if (!this.submitForm.category_id || !this.submitForm.goods_name) {
        this.$message({
          message: "商品品类和商品名称不能为空",
          type: "warning"
        });
        return;
      }
      var data = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.submitForm), {}, {
        status: this.status,
        operation_type: 1
      });
      data.rent_label = data.rent_label.join(',');
      data.province_id = data.province && data.province[0] ? data.province[0] : "";
      data.show_ity = data.province && data.province[1] ? data.province[1] : "";
      data.carousel_img = data.carousel_img.join(',');
      data.custom = this.goodsParams.map(function (item) {
        return {
          'field_title': item.field_title,
          'field_val': item.field_type != 3 ? item.field_val : item.field_val.join(',')
        };
      });
      delete data.province;
      // console.log(data);
      if (!sessionStorage.getItem('goodsId')) {
        // 没有商品id，新增
        (0, _goods.addGoodsData)(data).then(function (res) {
          sessionStorage.setItem('goodsId', res.goods_id);
          _this3.$message({
            message: "保存成功",
            type: "success"
          });
        });
      } else {
        // 有商品id，编辑
        data.goods_id = sessionStorage.getItem('goodsId');
        (0, _goods.editGoodsData)(data).then(function (res) {
          _this3.$message({
            message: "保存成功",
            type: "success"
          });
        });
      }
    },
    // 获取品类对应的商品参数
    categoryChange: function () {
      var _categoryChange = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(val) {
        var _this4 = this;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (val) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return");
              case 2:
                _context.next = 4;
                return (0, _goods.getGoodsParameter)(val).then(function (res) {
                  _this4.goodsParams = [];
                  var _iterator = (0, _createForOfIteratorHelper2.default)(res),
                    _step;
                  try {
                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                      var item = _step.value;
                      item.field_val = "";
                      item.field_list = item.field_list.split(',');
                      _this4.goodsParams.push((0, _objectSpread2.default)({}, item));
                    }
                  } catch (err) {
                    _iterator.e(err);
                  } finally {
                    _iterator.f();
                  }
                });
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      function categoryChange(_x) {
        return _categoryChange.apply(this, arguments);
      }
      return categoryChange;
    }(),
    save: function save() {
      var that = this;
      // this.$confirm('商品信息变更需要平台审核，审核时间1个工作日，确定修改商品？', '修改商品', {
      // 	confirmButtonText: '确定',
      // 	cancelButtonText: '取消',
      // }).then(() => {
      that.$refs['ruleForm'].validate(function (valid) {
        if (valid) {
          // 检查商品参数必填项
          var _iterator2 = (0, _createForOfIteratorHelper2.default)(that.goodsParams),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var item = _step2.value;
              if (item.must_is && (!item.field_val || item.field_val.length === 0)) {
                that.$message({
                  message: "商品参数" + item.field_title + "必填",
                  type: "warning"
                });
                return;
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          that.status = 2; // 商品编辑之后,状态自动下架
          var data = (0, _objectSpread2.default)((0, _objectSpread2.default)({
            goods_id: that.editId
          }, that.submitForm), {}, {
            status: that.status,
            operation_type: 3
          });
          data.rent_label = data.rent_label.join(',');
          data.province_id = data.province[0];
          data.show_ity = data.province[1];
          data.carousel_img = data.carousel_img.join(',');
          data.custom = that.goodsParams.map(function (item) {
            return {
              'field_title': item.field_title,
              'field_val': item.field_type != 3 ? item.field_val : item.field_val.join(',')
            };
          });
          delete data.province;
          // console.log(data);
          (0, _goods.editGoodsData)(data).then(function (res) {
            that.$message({
              message: "保存成功",
              type: "success"
            });
            // that.$router.push({ name: 'goodsSuccess', params: { goodsId: that.editId, isEdit: true } });
          });
        } else {
          that.$message({
            message: "请检查表单错误",
            type: "error"
          });
          return false;
        }
      });
      // }).catch(() => {});
    },
    nextStep: function nextStep() {
      var _this5 = this;
      this.$refs['ruleForm'].validate(function (valid) {
        if (valid) {
          // 检查商品参数必填项
          for (var item in _this5.goodsParams) {
            if (item.must_is && !item.field_val) {
              _this5.$message({
                message: "商品参数" + item.field_title + "必填",
                type: "warning"
              });
              return;
            }
          }
          var data = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _this5.submitForm), {}, {
            status: _this5.status,
            operation_type: 3
          });
          data.rent_label = data.rent_label.join(',');
          data.province_id = data.province[0];
          data.show_ity = data.province[1];
          data.carousel_img = data.carousel_img.join(',');
          data.custom = _this5.goodsParams.map(function (item) {
            return {
              'field_title': item.field_title,
              'field_val': item.field_type != 3 ? item.field_val : item.field_val.join(',')
            };
          });
          delete data.province;
          // console.log(data);
          if (!sessionStorage.getItem('goodsId')) {
            // 没有商品id，新增
            (0, _goods.addGoodsData)(data).then(function (res) {
              sessionStorage.setItem('goodsId', res.goods_id);
              _this5.$emit('changeTab');
            });
          } else {
            // 有商品id，编辑
            data.goods_id = sessionStorage.getItem('goodsId');
            (0, _goods.editGoodsData)(data).then(function (res) {
              _this5.$emit('changeTab');
            });
          }
        } else {
          _this5.$message({
            message: "请检查表单错误",
            type: "error"
          });
          return false;
        }
      });
    },
    changeNumberInput: function changeNumberInput(key, value) {
      var pattern = /^[1-9][0-9]*$/; // 正整数的正则表达式
      // 不符合正整数时
      if (!pattern.test(value)) {
        // input 框绑定的内容为空
        this.submitForm[key] = '';
      }
    },
    bannerChange: function bannerChange(val, type) {
      if (type === 'sort') {
        this.submitForm.carousel_img = val;
        return;
      }
      if (type === 'del') {
        this.submitForm.carousel_img.splice(val, 1);
      } else {
        this.submitForm.carousel_img.push(val);
      }
      this.$refs.cropUpload.sortList = this.submitForm.carousel_img;
    },
    setUrl: function setUrl(val) {
      this.submitForm.imgurl = val;
    },
    handleTagClick: function handleTagClick(tag) {
      var index = this.submitForm.rent_label.findIndex(function (item) {
        return item === tag;
      });
      if (index > -1) {
        this.submitForm.rent_label.splice(index, 1);
      } else {
        this.submitForm.rent_label.push(tag);
      }
    },
    // 判断标签是否选中
    isTagCheck: function isTagCheck(tag) {
      return this.submitForm.rent_label.findIndex(function (item) {
        return item === tag;
      }) > -1;
    },
    init: function init() {
      var _this6 = this;
      (0, _goods.getShopCategory)().then(function (res) {
        _this6.categoryList = res || [];
      });
      (0, _index.getAreas)().then(function (res) {
        _this6.areaList = res ? res[0].sub : [];
      });
      (0, _goods.getGoodsRentData)().then(function (res) {
        if (res) {
          _this6.initData = res;
        }
      });
    },
    getData: function getData() {
      var _this7 = this;
      if (this.editId) {
        // 编辑
        (0, _goods.getGoodsData)(this.editId).then( /*#__PURE__*/function () {
          var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee2(res) {
            var key, _iterator3, _step3, item, _iterator4, _step4, param;
            return (0, _regeneratorRuntime2.default)().wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _this7.hideAuditBtn = res.ischeck == 3;
                    for (key in _this7.submitForm) {
                      if (key === 'carousel_img') {
                        _this7.submitForm[key] = res.carousel_images ? res.carousel_images.split(',') : [];
                        _this7.$refs.cropUpload.sortList = _this7.submitForm.carousel_img;
                      } else if (key === 'goods_name') {
                        _this7.submitForm[key] = res.title;
                      } else if (key === 'province') {
                        _this7.submitForm[key] = [res.province_id, res.show_ity];
                      } else if (key === 'rent_label') {
                        _this7.submitForm[key] = res.rent_label.split(',');
                      } else if (key === 'pact_type') {
                        _this7.submitForm[key] = res.pact_type + '';
                      } else if (key === 'return') {
                        _this7.submitForm[key] = res.convey_type2 + '';
                      } else if (key === 'send_out') {
                        _this7.submitForm[key] = res.convey_type1 + '';
                      } else if (res[key]) {
                        _this7.submitForm[key] = res[key];
                      }
                    }
                    _this7.status = res.status;
                    _context2.next = 5;
                    return _this7.categoryChange(res.category_id);
                  case 5:
                    _iterator3 = (0, _createForOfIteratorHelper2.default)(res.attribute);
                    try {
                      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                        item = _step3.value;
                        _iterator4 = (0, _createForOfIteratorHelper2.default)(_this7.goodsParams);
                        try {
                          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                            param = _step4.value;
                            if (item.field_title === param.field_title) {
                              param.field_val = param.field_type == 3 ? item.field_val.split(',') : item.field_val;
                            }
                          }
                        } catch (err) {
                          _iterator4.e(err);
                        } finally {
                          _iterator4.f();
                        }
                      }
                    } catch (err) {
                      _iterator3.e(err);
                    } finally {
                      _iterator3.f();
                    }
                  case 7:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));
          return function (_x2) {
            return _ref.apply(this, arguments);
          };
        }());
      } else if (this.draftId) {
        (0, _goods.getGoodsAndSetmeal)(this.draftId).then( /*#__PURE__*/function () {
          var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee3(res) {
            var key, _iterator5, _step5, item, _iterator6, _step6, param;
            return (0, _regeneratorRuntime2.default)().wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    // console.log(res);
                    sessionStorage.setItem('goodsId', res.id);
                    for (key in _this7.submitForm) {
                      if (key === 'carousel_img') {
                        _this7.submitForm[key] = res.carousel_images ? res.carousel_images.split(',') : [];
                        _this7.$refs.cropUpload.sortList = _this7.submitForm.carousel_img;
                      } else if (key === 'goods_name') {
                        _this7.submitForm[key] = res.title;
                      } else if (key === 'province') {
                        _this7.submitForm[key] = res.province_id && res.show_ity ? [res.province_id, res.show_ity] : [];
                      } else if (key === 'rent_label') {
                        _this7.submitForm[key] = res.rent_label ? res.rent_label.split(',') : [];
                      } else if (key === 'pact_type') {
                        _this7.submitForm[key] = res.pact_type + '';
                      } else if (key === 'return') {
                        _this7.submitForm[key] = res.convey_type2 + '';
                      } else if (key === 'send_out') {
                        _this7.submitForm[key] = res.convey_type1 + '';
                      } else if (res[key]) {
                        _this7.submitForm[key] = res[key];
                      }
                    }
                    _this7.status = res.status || 2;
                    _context3.next = 5;
                    return _this7.categoryChange(res.category_id);
                  case 5:
                    _iterator5 = (0, _createForOfIteratorHelper2.default)(res.attribute);
                    try {
                      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                        item = _step5.value;
                        _iterator6 = (0, _createForOfIteratorHelper2.default)(_this7.goodsParams);
                        try {
                          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                            param = _step6.value;
                            if (item.field_title === param.field_title) {
                              param.field_val = param.field_type == 3 ? item.field_val.split(',') : item.field_val;
                            }
                          }
                        } catch (err) {
                          _iterator6.e(err);
                        } finally {
                          _iterator6.f();
                        }
                      }
                    } catch (err) {
                      _iterator5.e(err);
                    } finally {
                      _iterator5.f();
                    }
                    _this7.setMealList(res.setmeal);
                  case 8:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          }));
          return function (_x3) {
            return _ref2.apply(this, arguments);
          };
        }());
      } else {
        // 新增
        if (sessionStorage.getItem('baseInfo')) {
          var data = JSON.parse(sessionStorage.getItem('baseInfo'));
          // console.log(data);
          this.submitForm = (0, _objectSpread2.default)({}, data.formData);
          this.goodsParams = (0, _toConsumableArray2.default)(data.goodsParams);
        }
        this.status = parseInt(sessionStorage.getItem('goodsStatus')) || 2;
      }
    },
    setMealList: function setMealList(mealList) {
      var list = mealList.map(function (item) {
        var formData = {
          setmeal_id: "",
          title: "",
          lease_set: 1,
          is_huabei: 2,
          huabei_data: [{
            lease_term: "",
            rent_total: "",
            three_bear: "",
            three_fee: "",
            six_bear: "",
            six_fee: "",
            twelve_bear: "",
            twelve_fee: ""
          }],
          quantity: "",
          foregift: "",
          is_buy_out: 1,
          price: "",
          start_date: ""
        };
        var monthList = [{
          lease_time: null,
          lease_price: ""
        }];
        var dayList = [{
          lease_time: "",
          lease_price: ""
        }];
        var customList = [];
        for (var key in formData) {
          if (key === 'huabei_data') {
            if (item.is_huabei == 1) {
              formData[key] = item[key];
            }
          } else if (key === 'setmeal_id') {
            formData[key] = item.id;
          } else {
            formData[key] = item[key];
          }
        }
        if (item.lease_set == 1) {
          monthList = item.spec;
        } else if (item.lease_set == 2) {
          dayList = item.spec;
        } else {
          customList = item.spec;
        }
        return {
          formData: formData,
          monthList: monthList,
          dayList: dayList,
          customList: customList
        };
      });
      sessionStorage.setItem('mealInfo', JSON.stringify(list));
      this.$parent.mealTabs = JSON.parse(sessionStorage.getItem('mealInfo')).length;
    }
  },
  mounted: function mounted() {
    this.init();
    this.getData();
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.editId) {
      sessionStorage.setItem('baseInfo', JSON.stringify({
        formData: this.submitForm,
        goodsParams: this.goodsParams
      }));
      sessionStorage.setItem('goodsStatus', this.status);
    }
  }
};
exports.default = _default;